function ItemIssueIcon(props) {
  const { isActive } = props
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66667 14.6667C4.3 14.6667 3.98622 14.5362 3.72533 14.2753C3.46444 14.0145 3.33378 13.7004 3.33333 13.3333C3.33289 12.9662 3.46355 12.6524 3.72533 12.392C3.98711 12.1316 4.30089 12.0009 4.66667 12C5.03244 11.9991 5.34644 12.1298 5.60867 12.392C5.87089 12.6542 6.00133 12.968 6 13.3333C5.99867 13.6987 5.86822 14.0127 5.60867 14.2753C5.34911 14.538 5.03511 14.6685 4.66667 14.6667ZM11.3333 14.6667C10.9667 14.6667 10.6529 14.5362 10.392 14.2753C10.1311 14.0145 10.0004 13.7004 10 13.3333C9.99956 12.9662 10.1302 12.6524 10.392 12.392C10.6538 12.1316 10.9676 12.0009 11.3333 12C11.6991 11.9991 12.0131 12.1298 12.2753 12.392C12.5376 12.6542 12.668 12.968 12.6667 13.3333C12.6653 13.6987 12.5349 14.0127 12.2753 14.2753C12.0158 14.538 11.7018 14.6685 11.3333 14.6667ZM0.666666 2.66667V1.33334H2.85L5.68333 7.33334H10.35L12.95 2.66667H14.4667L11.15 8.66667H5.4L4.66667 10H12.6667V11.3333H2.41667L4.4 7.73334L2 2.66667H0.666666ZM7.33333 4.00001V0.666672H8.66667V4.00001H7.33333ZM7.33333 6.33334V5.00001H8.66667V6.33334H7.33333Z"
        fill={!isActive ? '#828282' : '#FFFFFF'}
      />
    </svg>
  )
}

export default ItemIssueIcon
